import styled from 'styled-components'

export const HeroContainer = styled.div`
  display: flex;
  align-items: flex-end;
  margin: 0;
`

export const HeroImage = styled.img`
  margin-top: 16px;
  width: 100%;
  height: auto;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 120px);
  padding-bottom: 140px;
  background-color: var(--neutral-theme);
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 24px 24px 24px;
  margin-bottom: 16px;
`

export const FeatureList = styled.div`
  display: flex;
  padding-top: 16px;
  flex-direction: column;
  gap: 16px;
`

export const FeatureItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  min-height: 24px;
`

export const Footer = styled.div`
  display: flex;
  position: fixed;
  flex-direction: column;
  gap: 16px;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 24px;
  background-color: var(--neutral-theme);
  border-top: 1px solid var(--gray200);
`
